// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Pakistan */
const PK = /^(?:3(?:[0-247]\d|3[0-79]|55|64)\d{7})$/;

export default PK;
